import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import React from 'react';
import App from './App';

import { modes as defaultModes, extensions as defaultExtensions } from './pluginImports';
import loadDynamicConfig from './loadDynamicConfig';
import keycloak from './keycloak'; // <-- Add this

export { history } from './utils/history';
export { preserveQueryParameters, preserveQueryStrings } from './utils/preserveQueryParameters';

loadDynamicConfig(window.config).then(async config_json => {
  if (config_json !== null) {
    window.config = config_json;
  }

  try {
    const authenticated = await keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256',
    });

    if (!authenticated) {
      await keycloak.login();
      return;
    }

    console.log('✅ Logged in as:', keycloak.tokenParsed?.preferred_username);
    window.keycloak = keycloak;

    const appProps = {
      config: window.config,
      defaultExtensions,
      defaultModes,
    };

    const container = document.getElementById('root');
    const root = createRoot(container);

    root.render(React.createElement(App, appProps));
  } catch (err) {
    console.error('Keycloak initialization failed', err);
  }
});

// /**
//  * Entry point for development and production PWA builds.
//  */
// import 'regenerator-runtime/runtime';
// import { createRoot } from 'react-dom/client';
// import App from './App';
// import React from 'react';

// /**
//  * EXTENSIONS AND MODES
//  * =================
//  * pluginImports.js is dynamically generated from extension and mode
//  * configuration at build time.
//  *
//  * pluginImports.js imports all of the modes and extensions and adds them
//  * to the window for processing.
//  */
// import { modes as defaultModes, extensions as defaultExtensions } from './pluginImports';
// import loadDynamicConfig from './loadDynamicConfig';
// export { history } from './utils/history';
// export { preserveQueryParameters, preserveQueryStrings } from './utils/preserveQueryParameters';

// loadDynamicConfig(window.config).then(config_json => {
//   // Reset Dynamic config if defined
//   if (config_json !== null) {
//     window.config = config_json;
//   }

//   /**
//    * Combine our appConfiguration with installed extensions and modes.
//    * In the future appConfiguration may contain modes added at runtime.
//    *  */
//   const appProps = {
//     config: window ? window.config : {},
//     defaultExtensions,
//     defaultModes,
//   };

//   const container = document.getElementById('root');

//   const root = createRoot(container);
//   root.render(React.createElement(App, appProps));
// });
